import PropTypes from 'prop-types';

const MoreSvg = ({ color, width, height }) => {
  return (
    <svg
      width={`${width || 25}`}
      height={`${height || 24}`}
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.4"
        d="M16.69 2H8.31C4.67 2 2.5 4.17 2.5 7.81V16.18C2.5 19.83 4.67 22 8.31 22H16.68C20.32 22 22.49 19.83 22.49 16.19V7.81C22.5 4.17 20.33 2 16.69 2Z"
        fill={color}
      />
      <path
        d="M12.5004 10.6899C11.7804 10.6899 11.1904 11.2799 11.1904 11.9999C11.1904 12.7199 11.7804 13.3099 12.5004 13.3099C13.2204 13.3099 13.8104 12.7199 13.8104 11.9999C13.8104 11.2799 13.2204 10.6899 12.5004 10.6899Z"
        fill={color}
      />
      <path
        d="M7.50043 10.6899C6.78043 10.6899 6.19043 11.2799 6.19043 11.9999C6.19043 12.7199 6.78043 13.3099 7.50043 13.3099C8.22043 13.3099 8.81043 12.7199 8.81043 11.9999C8.81043 11.2799 8.22043 10.6899 7.50043 10.6899Z"
        fill={color}
      />
      <path
        d="M17.5004 10.6899C16.7804 10.6899 16.1904 11.2799 16.1904 11.9999C16.1904 12.7199 16.7804 13.3099 17.5004 13.3099C18.2204 13.3099 18.8104 12.7199 18.8104 11.9999C18.8104 11.2799 18.2204 10.6899 17.5004 10.6899Z"
        fill={color}
      />
    </svg>
  );
};

MoreSvg.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
};

export default MoreSvg;
